export class RegexUtil {
    public static IDENTIFICATION_CODE =  '^[a-zA-Z0-9]+$';
    public static NOT_SPECIAL_CHARS =  /[^a-zA-Z0-9]+/g;
    public static EMAIL = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[A-Za-z]{2,}';
    public static FILES_SIGNATURES = '(.*?)\.(gif|jpg|jpeg|png|svg)$';
    public static FILES_ENVELOPES = '(.*?)\.(pdf|doc|docx|rtf)$';
    public static ONLY_DIGITS = /\D/g;
    public static NAME_INITIALS = /\b\w/g;
    public static VERIFICATION_CODE = /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/;
    public static DOCUMENT_CODE = '^[a-zA-Z0-9]{6}$';
    public static URL_VALIDATION = /^(https?:\/\/)(localhost|(\d{1,3}\.){3}\d{1,3}|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:\d+)?(\/\S*)?$/;
    public static NOT_NULL_OR_WHITE_SPACE = /^(?!\s*$).+/;
}